// extracted by mini-css-extract-plugin
module.exports = {"menu":"MobileMenu_menu__10TNu","item":"MobileMenu_item__Srf_4","close":"MobileMenu_close__LjaOG"};